import { doc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../config';
import { parseHealthImportDocId } from '@/lib/health/healthImportIds';

/**
 * Web never imports health data — only a phone can read a health store. It has
 * exactly one job here: when a user deletes an entry that WAS imported, say so
 * permanently, so the phone's next import pass does not recreate it.
 */
export const TOMBSTONES_COLLECTION = 'healthImportTombstones';

export async function recordImportTombstone(docId: string): Promise<void> {
  const parsed = parseHealthImportDocId(docId);
  if (!parsed) return;
  try {
    await setDoc(doc(db, TOMBSTONES_COLLECTION, docId), {
      userId: parsed.userId,
      kind: parsed.kind,
      deletedAt: Timestamp.now(),
    });
  } catch (error) {
    console.warn('[healthImport] tombstone write failed', error);
  }
}
